// src/billing/topUpBaseline.js — the wallet total from just BEFORE a top-up
// checkout, carried across the round trip to Stripe.
//
// ⛔ Why this exists at all: on the way back, the rise cannot be measured. The
// webhook normally credits the wallet BEFORE the browser returns from Stripe —
// measured 2026-09-07, the webhook landed at 12:59:46, before /credits had even
// rendered — so the first balance read there already includes the pack and
// "has it gone up since I arrived?" is false for ever. The banner then sat on
// "payment received" and went on to claim crediting was slow, on a purchase
// that had already succeeded.
//
// Written (best-effort) by sections/Piani.jsx on the pack confirm; read and
// cleared by sections/Credits.jsx on /credits?topup=done.
//
// sessionStorage, not localStorage: this must survive the redirect (same tab,
// same origin) and die with the tab. A stale baseline outliving its purchase
// would make the NEXT visit read as a fresh credit.
//
// Keyed by workspace, so one wallet's total is never STORED under another's.
// ⚠️ That alone is not what stops a mid-flight comparison: the reader holds the
// baseline in a ref that is only initialised once. What actually protects it is
// that switching workspace unmounts /credits (the picker lives outside
// AppShell), taking the ref with it. If that ever stops being true, the reader
// must re-read this per tenant rather than trust the key.
//
// ⚠️ Every access is guarded: storage throws outright in some privacy modes.
// A failure degrades to "no baseline", which the return page renders as a
// neutral "payment received, balance below is current" — never as a failure.

export const topUpBaselineKey = (tenantId) => `topup_baseline:${tenantId}`;

export function writeTopUpBaseline(tenantId, remaining) {
  if (remaining == null) return;
  try { window.sessionStorage.setItem(topUpBaselineKey(tenantId), String(remaining)); }
  catch { /* storage blocked — the return page degrades to a neutral notice */ }
}

export function readTopUpBaseline(tenantId) {
  try { return window.sessionStorage.getItem(topUpBaselineKey(tenantId)); }
  catch { return null; }
}

export function clearTopUpBaseline(tenantId) {
  try { window.sessionStorage.removeItem(topUpBaselineKey(tenantId)); }
  catch { /* nothing to clean up */ }
}
